

import React from 'react'
import { Table } from '../../../admin/components/Table/Table'
import Button from '../../../utils/components/Button/Button'
import { formatPrice } from '../../../utils/functions'



const PurchasesDetail = ({ infoOrder, subOrders, pay }) => {

  if (!infoOrder) {
    return (
      <div className='column centerContent'>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
    )
  }
  let isToComplete = true
  let isTicket = false
  let isBankTransfer = false
  let isApproved = false

  if (infoOrder.payment_type) {

    if (infoOrder.payment_type ==="ticket") {
      isTicket = true
    }
    if (infoOrder.payment_type ==="bank_transfer") {
      isBankTransfer = true
    }
    if (infoOrder.status !== "pending" || infoOrder.status !== "rejected") {
      // isApproved = true

    }
    if (infoOrder.status ==="pending") {//si esta pendiente

      isToComplete = true
      if (isTicket) {//si esta pendiente pero pue por medio en efectivo
        isToComplete = false
      }
      if (isBankTransfer) {//si esta pendiente pero pue por medio en efectivo
        isToComplete = false
      }

    }
    if (infoOrder.status ==="rejected") {//si fue rechazado
      isToComplete = true
    }
    if(infoOrder.status ==="approved"){
      isApproved=true
      isToComplete = false
    }

  }

  return (
    <div>
      {
        isToComplete && (
          <div className='column'>
            <Button
              onClick={() => {
                pay(infoOrder.preference_id)
              }}
              text='Completar pago' />
          </div>
        )
      }
      {
        !isApproved && isTicket && (
          <div>
            Deber ir a pagar a un punto Efecty
          </div>
        )
      }
      {
        !isApproved && isBankTransfer && (
          <div>
            Deber completar tu pago con pse
          </div>
        )
      }
      <Table>
        <thead>
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th>Cantidad</th>
            <th>Precio unitario</th>
            <th>Precio total</th>
          </tr>
        </thead>
        <tbody>

          {
            subOrders.map(subOrder => (
              <tr>
                <td>{subOrder.productId.code}</td>
                <td> {subOrder.productId.name}</td>
                <td> {subOrder.orderedQuantity}</td>
                <td> {formatPrice(subOrder.unitPrice)}</td>
                <td> {formatPrice(subOrder.totalPrice)}</td>

              </tr>
            ))
          }
        </tbody>

      </Table>


    </div>
  )
}

export default PurchasesDetail